import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { getQuizDetails } from "../../../api/endpoints/QuizEndpoints";

export default function useGetQuizDetails(quizId: string) {
  const getExerciseDetailsFn = useCallback(() => {
    return getQuizDetails(quizId);
  }, [quizId]);

  return useQuery({
    queryKey: ["quiz", quizId],
    queryFn: getExerciseDetailsFn,
  });
}
